import { GetCurrentUserUseCaseImpl } from "@/domain/usecaseimpl/user/GetCurrentUserUseCaseImpl";
import { GetFeedUseCaseImpl } from "@/domain/usecaseimpl/tweet/GetFeedUseCaseImpl";
import { LoginUseCaseImpl } from "@/domain/usecaseimpl/auth/LoginUseCaseImpl";
import { PostTweetUseCaseImpl } from "@/domain/usecaseimpl/tweet/PostTweetUseCaseImpl";
import { SignUpUseCaseImpl } from "@/domain/usecaseimpl/auth/SignUpUseCaseImpl";
import { provideAuthRepository, provideTweetRepository, provideUserRepository } from "./provideRepositories";
import { GetUsersUseCaseImpl } from "@/domain/usecaseimpl/user/GetUsersUseCaseImpl";
import { FindUserUseCaseImpl } from "@/domain/usecaseimpl/user/FindUserUseCaseImpl";
import { UpdateProfileUseCaseImpl } from "@/domain/usecaseimpl/user/UpdateProfileUseCaseImpl";
import { LogoutUseCaseImpl } from "@/domain/usecaseimpl/auth/LogoutUseCaseImpl";
import { FollowUserUseCaseImpl } from "@/domain/usecaseimpl/follow/FollowUserUseCaseImpl";
import { UnfollowUserUseCaseImpl } from "@/domain/usecaseimpl/follow/UnfollowUserUseCaseImpl";
import { GetTweetsByUserUseCaseImpl } from "@/domain/usecaseimpl/tweet/GetTweetsByUserUseCaseImpl";
import { GetAuthStateUseCaseImpl } from "@/domain/usecaseimpl/auth/GetAuthStateUseCaseImpl";
import { SendPasswordResetEmailUseCaseImpl } from "@/domain/usecaseimpl/auth/SendPasswordResetEmailUseCaseImpl";
import { LikeTweetUseCaseImpl } from "@/domain/usecaseimpl/tweet/LikeTweetUseCaseImpl";
import { GetFollowersUseCaseImpl } from "@/domain/usecaseimpl/follow/GetFollowersUseCaseImpl";
export function provideGetCurrentUserUseCase() {
    return new GetCurrentUserUseCaseImpl(provideAuthRepository(), provideUserRepository());
}
export function provideGetFeedUseCase() {
    return new GetFeedUseCaseImpl(provideTweetRepository(), provideGetCurrentUserUseCase());
}
export function provideGetTweetsByUserUseCase() {
    return new GetTweetsByUserUseCaseImpl(provideTweetRepository(), provideUserRepository());
}
export function provideLoginUseCase() {
    return new LoginUseCaseImpl(provideAuthRepository());
}
export function provideSendPasswordResetEmailUseCase() {
    return new SendPasswordResetEmailUseCaseImpl(provideAuthRepository());
}
export function providePostTweetUseCase() {
    return new PostTweetUseCaseImpl(provideTweetRepository(), provideGetCurrentUserUseCase());
}
export function provideLikeTweetUseCase() {
    return new LikeTweetUseCaseImpl(provideTweetRepository(), provideAuthRepository());
}
export function provideSignUpUseCase() {
    return new SignUpUseCaseImpl(provideAuthRepository(), provideUserRepository());
}
export function provideGetUsersUseCase() {
    return new GetUsersUseCaseImpl(provideUserRepository(), provideAuthRepository());
}
export function provideFindUserUseCase() {
    return new FindUserUseCaseImpl(provideUserRepository());
}
export function provideUpdateProfileUseCase() {
    return new UpdateProfileUseCaseImpl(provideUserRepository(), provideAuthRepository());
}
export function provideLogoutUseCase() {
    return new LogoutUseCaseImpl(provideAuthRepository());
}
export function provideFollowUserUseCase() {
    return new FollowUserUseCaseImpl(provideUserRepository(), provideAuthRepository());
}
export function provideUnfollowUserUseCase() {
    return new UnfollowUserUseCaseImpl(provideUserRepository(), provideAuthRepository());
}
export function provideGetAuthStateUseCase() {
    return new GetAuthStateUseCaseImpl(provideAuthRepository());
}
export function provideGetFollowersUseCase() {
    return new GetFollowersUseCaseImpl(provideUserRepository());
}
